module.exports = __webpack_public_path__ + "img/home-banner.f702608.png";